/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfListOfGetSmartSmsClubsListDto } from '../models/custom-result-of-list-of-get-smart-sms-clubs-list-dto';
import { CustomResultOfListOfGetSmartSmsClubStatusInGatewayDto } from '../models/custom-result-of-list-of-get-smart-sms-club-status-in-gateway-dto';
import { CustomResultOfPaginatedListOfGetSmartSmsClubFileProgressesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-smart-sms-club-file-progresses-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetSmartSmsClubNumbersDto } from '../models/custom-result-of-paginated-list-of-get-smart-sms-club-numbers-dto';
import { CustomResultOfPaginatedListOfSmartSmsClubsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-smart-sms-clubs-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { smartSmsClubsAddNumbersToClub } from '../fn/smart-sms-clubs/smart-sms-clubs-add-numbers-to-club';
import { SmartSmsClubsAddNumbersToClub$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-add-numbers-to-club';
import { smartSmsClubsCreateGet } from '../fn/smart-sms-clubs/smart-sms-clubs-create-get';
import { SmartSmsClubsCreateGet$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-create-get';
import { smartSmsClubsCreatePost } from '../fn/smart-sms-clubs/smart-sms-clubs-create-post';
import { SmartSmsClubsCreatePost$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-create-post';
import { smartSmsClubsDelete } from '../fn/smart-sms-clubs/smart-sms-clubs-delete';
import { SmartSmsClubsDelete$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-delete';
import { smartSmsClubsGetSmartSmsClubFileProgressesWithPagination } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-club-file-progresses-with-pagination';
import { SmartSmsClubsGetSmartSmsClubFileProgressesWithPagination$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-club-file-progresses-with-pagination';
import { smartSmsClubsGetSmartSmsClubNumbers } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-club-numbers';
import { SmartSmsClubsGetSmartSmsClubNumbers$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-club-numbers';
import { smartSmsClubsGetSmartSmsClubsList } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-clubs-list';
import { SmartSmsClubsGetSmartSmsClubsList$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-clubs-list';
import { smartSmsClubsGetSmartSmsClubStatusInGateway } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-club-status-in-gateway';
import { SmartSmsClubsGetSmartSmsClubStatusInGateway$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-club-status-in-gateway';
import { smartSmsClubsGetSmartSmsClubsWithPagination } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-clubs-with-pagination';
import { SmartSmsClubsGetSmartSmsClubsWithPagination$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-get-smart-sms-clubs-with-pagination';
import { smartSmsClubsUploadSmartSmsClubFile } from '../fn/smart-sms-clubs/smart-sms-clubs-upload-smart-sms-club-file';
import { SmartSmsClubsUploadSmartSmsClubFile$Params } from '../fn/smart-sms-clubs/smart-sms-clubs-upload-smart-sms-club-file';

@Injectable({ providedIn: 'root' })
export class SmartSmsClubsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smartSmsClubsCreateGet()` */
  static readonly SmartSmsClubsCreateGetPath = '/SmartSmsClubs/Create';

  /**
   * بررسی دسترسی ایجاد باشگاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsClubsCreateGet$Response(params?: SmartSmsClubsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsClubsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی ایجاد باشگاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsClubsCreateGet(params?: SmartSmsClubsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsClubsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsCreatePost()` */
  static readonly SmartSmsClubsCreatePostPath = '/SmartSmsClubs/Create';

  /**
   * ایجاد باشگاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsCreatePost$Response(params: SmartSmsClubsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsClubsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد باشگاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsCreatePost(params: SmartSmsClubsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsClubsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsDelete()` */
  static readonly SmartSmsClubsDeletePath = '/SmartSmsClubs/Delete';

  /**
   * حذف کمپین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsDelete$Response(params: SmartSmsClubsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsClubsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف کمپین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsDelete(params: SmartSmsClubsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsClubsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsGetSmartSmsClubsWithPagination()` */
  static readonly SmartSmsClubsGetSmartSmsClubsWithPaginationPath = '/SmartSmsClubs/GetSmartSmsClubsWithPagination';

  /**
   * دریافت لیست باشگاه های سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsGetSmartSmsClubsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsGetSmartSmsClubsWithPagination$Response(params: SmartSmsClubsGetSmartSmsClubsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfSmartSmsClubsWithPaginationDto>> {
    return smartSmsClubsGetSmartSmsClubsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست باشگاه های سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsGetSmartSmsClubsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsGetSmartSmsClubsWithPagination(params: SmartSmsClubsGetSmartSmsClubsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfSmartSmsClubsWithPaginationDto> {
    return this.smartSmsClubsGetSmartSmsClubsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfSmartSmsClubsWithPaginationDto>): CustomResultOfPaginatedListOfSmartSmsClubsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsAddNumbersToClub()` */
  static readonly SmartSmsClubsAddNumbersToClubPath = '/SmartSmsClubs/AddNumbersToClub';

  /**
   * افزودن شماره به باشگاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsAddNumbersToClub()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsAddNumbersToClub$Response(params: SmartSmsClubsAddNumbersToClub$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsClubsAddNumbersToClub(this.http, this.rootUrl, params, context);
  }

  /**
   * افزودن شماره به باشگاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsAddNumbersToClub$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsAddNumbersToClub(params: SmartSmsClubsAddNumbersToClub$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsClubsAddNumbersToClub$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsGetSmartSmsClubsList()` */
  static readonly SmartSmsClubsGetSmartSmsClubsListPath = '/SmartSmsClubs/GetSmartSmsClubsList';

  /**
   * دریافت لیست باشگاه های سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsGetSmartSmsClubsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsClubsGetSmartSmsClubsList$Response(params?: SmartSmsClubsGetSmartSmsClubsList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSmartSmsClubsListDto>> {
    return smartSmsClubsGetSmartSmsClubsList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست باشگاه های سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsGetSmartSmsClubsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsClubsGetSmartSmsClubsList(params?: SmartSmsClubsGetSmartSmsClubsList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSmartSmsClubsListDto> {
    return this.smartSmsClubsGetSmartSmsClubsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSmartSmsClubsListDto>): CustomResultOfListOfGetSmartSmsClubsListDto => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsUploadSmartSmsClubFile()` */
  static readonly SmartSmsClubsUploadSmartSmsClubFilePath = '/SmartSmsClubs/UploadSmartSmsClubFile';

  /**
   * آپلود فایل افزودن شماره به باشگاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsUploadSmartSmsClubFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsClubsUploadSmartSmsClubFile$Response(params?: SmartSmsClubsUploadSmartSmsClubFile$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return smartSmsClubsUploadSmartSmsClubFile(this.http, this.rootUrl, params, context);
  }

  /**
   * آپلود فایل افزودن شماره به باشگاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsUploadSmartSmsClubFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsClubsUploadSmartSmsClubFile(params?: SmartSmsClubsUploadSmartSmsClubFile$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.smartSmsClubsUploadSmartSmsClubFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsGetSmartSmsClubFileProgressesWithPagination()` */
  static readonly SmartSmsClubsGetSmartSmsClubFileProgressesWithPaginationPath = '/SmartSmsClubs/GetSmartSmsClubFileProgressesWithPagination';

  /**
   * دریافت لیست فایل های آپلود شده کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsGetSmartSmsClubFileProgressesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsGetSmartSmsClubFileProgressesWithPagination$Response(params: SmartSmsClubsGetSmartSmsClubFileProgressesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsClubFileProgressesWithPaginationDto>> {
    return smartSmsClubsGetSmartSmsClubFileProgressesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست فایل های آپلود شده کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsGetSmartSmsClubFileProgressesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsGetSmartSmsClubFileProgressesWithPagination(params: SmartSmsClubsGetSmartSmsClubFileProgressesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSmartSmsClubFileProgressesWithPaginationDto> {
    return this.smartSmsClubsGetSmartSmsClubFileProgressesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsClubFileProgressesWithPaginationDto>): CustomResultOfPaginatedListOfGetSmartSmsClubFileProgressesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsGetSmartSmsClubStatusInGateway()` */
  static readonly SmartSmsClubsGetSmartSmsClubStatusInGatewayPath = '/SmartSmsClubs/GetSmartSmsClubStatusInGateway';

  /**
   * استعلام وضعیت ایجاد باشگاه هوشمند در گت وی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsGetSmartSmsClubStatusInGateway()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsClubsGetSmartSmsClubStatusInGateway$Response(params?: SmartSmsClubsGetSmartSmsClubStatusInGateway$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSmartSmsClubStatusInGatewayDto>> {
    return smartSmsClubsGetSmartSmsClubStatusInGateway(this.http, this.rootUrl, params, context);
  }

  /**
   * استعلام وضعیت ایجاد باشگاه هوشمند در گت وی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsGetSmartSmsClubStatusInGateway$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsClubsGetSmartSmsClubStatusInGateway(params?: SmartSmsClubsGetSmartSmsClubStatusInGateway$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSmartSmsClubStatusInGatewayDto> {
    return this.smartSmsClubsGetSmartSmsClubStatusInGateway$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSmartSmsClubStatusInGatewayDto>): CustomResultOfListOfGetSmartSmsClubStatusInGatewayDto => r.body)
    );
  }

  /** Path part for operation `smartSmsClubsGetSmartSmsClubNumbers()` */
  static readonly SmartSmsClubsGetSmartSmsClubNumbersPath = '/SmartSmsClubs/GetSmartSmsClubNumbers';

  /**
   * دریافت لیست شماره های اضافه شده به باشگاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsClubsGetSmartSmsClubNumbers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsGetSmartSmsClubNumbers$Response(params: SmartSmsClubsGetSmartSmsClubNumbers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsClubNumbersDto>> {
    return smartSmsClubsGetSmartSmsClubNumbers(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست شماره های اضافه شده به باشگاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsClubsGetSmartSmsClubNumbers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsClubsGetSmartSmsClubNumbers(params: SmartSmsClubsGetSmartSmsClubNumbers$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSmartSmsClubNumbersDto> {
    return this.smartSmsClubsGetSmartSmsClubNumbers$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsClubNumbersDto>): CustomResultOfPaginatedListOfGetSmartSmsClubNumbersDto => r.body)
    );
  }

}
